// extracted by mini-css-extract-plugin
export default {"footer_container":"footer_footer_container__ckQnc","footer_header":"footer_footer_header__efUjf","footer_list":"footer_footer_list__0+Lm-","divider":"footer_divider__ooYf4"};